import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import { getI18n } from 'client/i18n'
import styles from './manage.less'
import { Link, withRouter } from 'react-router'
import { glimpseRoute } from 'lib/route_utils'
import CampaignInfo from 'components/pages/campaign/campaign_info'
import StandardEditPart from 'components/standard_edit_part'
import { formatMoney } from 'client/griffin'
import Separator from 'components/common/separator'
import NoCurrencyAlert from 'components/pages/campaign/no_currency_alert'

const i18n = getI18n('components/edit_glimpse/manage')

class Manage extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    hasChippedIn: PropTypes.bool,
    moneyboxAmount: PropTypes.number,
    hasMoneybox: PropTypes.bool,
    currencyCode: PropTypes.string,
    campaignId: PropTypes.string,
    contributorsCount: PropTypes.number,
    dispatch: PropTypes.func,
    hasCurrencyBalance: PropTypes.bool,
    pendingAmount: PropTypes.number,
    onTransfer: PropTypes.func,
    paypalDomain: PropTypes.string,
  }

  handleTransferClick = event => {
    if (!this.props.hasMoneybox) {
      event.preventDefault()
    } else {
      this.props.onTransfer()
    }
  }

  render() {
    const {
      hasCurrencyBalance,
      currencyCode,
      campaignId,
      hasChippedIn,
      pendingAmount,
      moneyboxAmount,
      hasMoneybox,
      paypalDomain,
    } = this.props
    return (
      <div>
        {!hasCurrencyBalance && (
          <NoCurrencyAlert
            paypalDomain={paypalDomain}
            currency={currencyCode}
          />
        )}
        <CampaignInfo campaignId={campaignId} compact={true} />
        <div>
          {hasChippedIn && (
            <div>
              <Separator type="dotted" />
              <StandardEditPart
                title={i18n('pool_balance')}
                description={
                  pendingAmount !== 0
                    ? i18n('pending', {
                        amount: formatMoney(currencyCode, pendingAmount, {
                          removeTrailingZeros: false,
                        }),
                      })
                    : ''
                }
                actionText={i18n('activity_link')}
                value={formatMoney(currencyCode, moneyboxAmount, {
                  removeTrailingZeros: false,
                })}
                targetLocation={glimpseRoute('edit', 'manage/activity')}
              />
            </div>
          )}
          <Link
            to={glimpseRoute('edit')}
            className="vx_btn vx_btn-block vx_btn-secondary"
            styleName="first-button"
            data-nemo="editPool"
          >
            {i18n('edit_pool')}
          </Link>
          {hasChippedIn && (
            <button
              onClick={this.handleTransferClick}
              disabled={!hasMoneybox}
              data-nemo="transfer-menu-button"
              className="vx_btn vx_btn-block vx_btn-secondary"
            >
              {i18n('transfer_link')}
            </button>
          )}
        </div>
      </div>
    )
  }
}

export default withRouter(cssModules(Manage, styles))
